export const ERROR_BOUNDARY_SET_ROOT_ERROR = 'ERROR_BOUNDARY_SET_ROOT_ERROR'

export const setErrorBoundaryRootError = (error) => ({
  type: ERROR_BOUNDARY_SET_ROOT_ERROR,
  data: error,
})
